import { CREATE_NOTIFICATION_BANNER, UPDATE_NOTIFICATION_BANNER } from "../../../gql/landingapi/mutations";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";

export const TopBannerMessagenotify = async (client, values, setValue, cancel, refetch) => {
  try {
    let displayMessage = "";

    let query = "";
    
    values.cidmGroupName = values.cidmGroupName?values.cidmGroupName:"null";

    if (values.id === "") {
      query = CREATE_NOTIFICATION_BANNER;
      displayMessage = "Top banner message successfully created";
    } else {
      query = UPDATE_NOTIFICATION_BANNER;
      displayMessage = "Top banner message successfully saved";
    }
  
    await client.mutate({
      mutation: query,
      variables: values
    });
    snackbarService.show({
      type: "success",
      message: displayMessage,
      duration: 2000
    })
    refetch();
    cancel();
  } catch (error) {
    snackbarService.show({
      type: "error",
      message: error.message || 'Top banner message updation failure',
      duration: 5000
    })
  }
};
